import { IDashboard } from "app/types";
import { LogoComponent } from "app/components/logo.component";
import { PlaceholderPage } from "modules/core/pages/placeholder.page";
import {
  FaBriefcase,
  FaDashcube,
  FaHistory,
  FaQuestionCircle,
  FaUserCircle
} from "react-icons/fa";
import { UserListPage } from "modules/user/pages/user-list.page";
import { CreateUserPage } from "modules/user/pages/create-user.page";
import { UserLogPage } from "modules/log/pages/user-log.page";
import { DashboardPage } from "modules/police-case/pages/dashboard.page";
import { CaseLogPage } from "modules/log/pages/case-log.page";
import { SearchCasePage } from "modules/police-case/pages/search-case.page";
import { CaseDetailsPage } from "modules/police-case/pages/case-details.page";
import { PatientDocumentPage } from "modules/police-case/pages/patient-document.page";
import { RecordRequestPage } from "modules/record-request/pages/record-request.page";
import { ConnectRecordRequestPage } from "modules/record-request/pages/connect-record-request.page";

export const medicalCertificationDashboard: IDashboard = {
  dashboardName: "medical-certification",
  logo: <LogoComponent />,
  pages: [
    {
      name: "Dashboard",
      link: "/medical-certification/dashboard",
      content: <DashboardPage />
    },
    {
      name: "User List",
      link: "/medical-certification/user/list",
      content: <UserListPage />
    },
    {
      name: "Add User",
      link: "/medical-certification/user/add",
      content: <CreateUserPage />
    },
    {
      name: "User Details",
      link: "/medical-certification/user/:userId/details",
      content: <PlaceholderPage />
    },
    {
      name: "Case List",
      link: "/medical-certification/case/list",
      content: <PlaceholderPage />
    },
    {
      name: "Search Case",
      link: "/medical-certification/case/search",
      content: <SearchCasePage />
    },
    {
      name: "Upload Case Documents",
      link: "/medical-certification/document/upload",
      content: <PatientDocumentPage />
    },
    {
      name: "Case Details",
      link: "/medical-certification/case/:caseId/details",
      content: <CaseDetailsPage />
    },
    {
      name: "User Logs",
      link: "/medical-certification/user/:userId/activity-log/list",
      content: <UserLogPage />
    },
    {
      name: "Case Logs",
      link: "/medical-certification/case/:caseId/activity-log/list",
      content: <CaseLogPage />
    },
    {
      name: "Record Request Details",
      link: "/medical-certification/record-request/:id",
      content: <ConnectRecordRequestPage />
    },
    {
      name: "Record Request List",
      link: "/medical-certification/record-request/list",
      content: <RecordRequestPage />
    }
  ],

  sidebar: [
    {
      header: "Dashboard",
      icon: FaDashcube,

      pages: [
        {
          name: "Overview",
          link: "/medical-certification/dashboard",
          content: <DashboardPage />
        }
      ]
    },
    // {
    //   name: "Dashboard",
    //   link: "/medical-certification/dashboard",
    //   content: <DashboardPage />
    // },
    {
      header: "Case Management",
      icon: FaBriefcase,
      pages: [
        // {
        //   name: "Case List",
        //   link: "/medical-certification/case/list",
        //   content: <SearchCasePage />
        // },
        {
          name: "Search Case",
          link: "/medical-certification/case/search",
          content: <SearchCasePage />
        }
        // {
        //   name: "Case Details",
        //   link: "/medical-certification/case/default/details",
        //   content: <CaseDetailsPage />
        // }
      ]
    },
    {
      header: "User Management",
      icon: FaUserCircle,
      pages: [
        {
          name: "User List",
          link: "/medical-certification/user/list",
          content: <PlaceholderPage />
        },
        {
          name: "Add User",
          link: "/medical-certification/user/add",
          content: <PlaceholderPage />
        }
        // {
        //   name: "User Details",
        //   link: "/medical-certification/user/default/details",
        //   content: <PlaceholderPage />
        // }
      ]
    },
    {
      header: "Activity Logs",
      icon: FaHistory,
      pages: [
        {
          name: "User Logs",
          link: "/medical-certification/user/default/activity-log/list",
          content: <UserLogPage />
        },
        {
          name: "Case Logs",
          link: "/medical-certification/case/default/activity-log/list",
          content: <CaseLogPage />
        }
      ]
    },
    {
      header: "Record Request",
      icon: FaQuestionCircle,
      pages: [
        {
          name: "Record Request List",
          link: "/medical-certification/record-request/list",
          content: <RecordRequestPage />
        }
      ]
    }
  ]
};
